import { render, staticRenderFns } from "./UsageInfo.vue?vue&type=template&id=66d0d089&"
import script from "./UsageInfo.vue?vue&type=script&lang=ts&"
export * from "./UsageInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d0d089')) {
      api.createRecord('66d0d089', component.options)
    } else {
      api.reload('66d0d089', component.options)
    }
    module.hot.accept("./UsageInfo.vue?vue&type=template&id=66d0d089&", function () {
      api.rerender('66d0d089', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/machinetranslations/UsageInfo.vue"
export default component.exports